import moment from 'moment';

export function formatToLocal(value) {
  if (!value) return '';

  let m;
  if (value.endsWith('Z') || /[+-]\d{2}:\d{2}$/.test(value)) {
    m = moment.utc(value).local();
  } else {
    m = moment(value);
  }

  return m.format('HH:mm Do MMMM YYYY');
}
